/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Payment_Filter_FromInputs */

const vi_grower_payment_filter_from = /** @type {(inputs: Grower_Payment_Filter_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ ngày`)
};

/**

* @param {Grower_Payment_Filter_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_payment_filter_from = /** @type {((inputs?: Grower_Payment_Filter_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Payment_Filter_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_payment_filter_from(inputs)
});